import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withTranslate from 'containers/widgets/withTranslate';
import toaster from 'utils/toaster';
import { TOAST_CONFIG } from '../constants';
import css from './QuestionField.css';

const QUESTION_FIELD_PREFIX = 'STATIC.PAGES.AI_CONTEXT.QUESTION_FIELD';

const QuestionField = ({ question, maxLength, value, onChange = () => {}, readOnly = false, translate }) => {
    const handlePaste = e => {
        if (!maxLength) return;
        const pasted = e.clipboardData.getData('text');
        const { selectionStart, selectionEnd } = e.target;
        const selectionLength = selectionEnd - selectionStart;
        const projectedLength = (value || '').length - selectionLength + pasted.length;
        if (projectedLength > maxLength) {
            toaster.warning(translate(`${QUESTION_FIELD_PREFIX}.PASTE_TRUNCATED`, { maxLength }), TOAST_CONFIG);
        }
    };

    const handleFocus = e => {
        if (readOnly) {
            e.target.blur();
        }
    };

    return (
        <div className={css.question}>
            <div className={css.header}>
                <div className={css.title}>{translate(question.title)}</div>
                <div className={css.description}>{translate(question.description)}</div>
            </div>
            <textarea
                className={classNames(css.textarea, { [css.readOnly]: readOnly })}
                placeholder={!readOnly && question.placeholder ? translate(question.placeholder) : ''}
                value={value || ''}
                maxLength={maxLength}
                readOnly={readOnly}
                tabIndex={readOnly ? -1 : undefined}
                onChange={e => !readOnly && onChange(question.id, e.target.value)}
                onFocus={handleFocus}
                onPaste={readOnly ? undefined : handlePaste}
            />
            <div
                className={classNames(css.charCount, {
                    [css.charCountLimit]: maxLength && (value || '').length >= maxLength,
                })}
            >
                {translate(
                    maxLength
                        ? `${QUESTION_FIELD_PREFIX}.CHARACTER_COUNT_WITH_LIMIT`
                        : `${QUESTION_FIELD_PREFIX}.CHARACTER_COUNT`,
                    { count: (value || '').length, maxLength }
                )}
            </div>
        </div>
    );
};

QuestionField.propTypes = {
    question: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
    }).isRequired,
    maxLength: PropTypes.number,
    value: PropTypes.string,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withTranslate(QuestionField);
